<app-input-control
	[label]="label()"
	[controlName]="controlName()"
	[placeholder]="placeholder()"
	[required]="required()"
	[minLength]="minLength()"
	[type]="type()"
	[formGroup]="formGroup()"
/>
